export const getGoogleSearchLink = (text: string) => {
  return `https://www.google.com/search?q=${text.toLocaleLowerCase().trim().replace(/\s+/g, '+')}`
}
